import * as React from 'react';
import { themr } from 'react-css-themr';
import Nav from '../Nav';
function DumpEntitiesNav({ list, route, onClick, showTotal, theme = {}, }) {
    const navItems = list.entities.map((item) => ({
        to: {
            name: route,
            params: {
                slug: item.slug,
            },
        },
        label: showTotal ? `${item.title} (${item.total || 0})` : item.title,
    }));
    return React.createElement(Nav, { theme: theme, items: navItems, onClick: onClick });
}
export const defaultEntitiesNavTheme = {};
const EntitiesNav = themr('EntitiesNav', {}, { composeTheme: 'softly' })(DumpEntitiesNav);
export default EntitiesNav;
//# sourceMappingURL=index.js.map